import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import Paragraph from '../../../../../../components/common/Paragraph';
import InfoModal from '../../../../../../components/data-display/InfoModal';

const LegalProfile = ({ HandleSurvey }) => 
  <>
    <Paragraph strong>Configuración de Perfil Inversionista</Paragraph>
    <div>
      <InfoModal buttonLabel="Sobre Perfil de Riesgo" title="Perfil de Riesgo" width={1020}>
        <p>
          Se refiere a las características de una persona que guían la manera en que debiera tomar
          sus decisiones de inversión, incluido su nivel de tolerancia al riesgo, en relación a los
          diversos instrumentos de inversión que existen en el mercado.
        </p>
        <p>
          En la medida que conozca qué tipo de inversionista es usted, podrá elegir de mejor forma
          entre las alternativas de inversión a las que puede optar o crear una mezcla de
          inversiones que se adapten a su perfil.
        </p>
        <p>
          Saber cuáles son las necesidades y objetivos de inversión actuales, cuál es el horizonte
          de inversión, la disponibilidad con la que necesitará el dinero, el nivel de riesgo con el
          que se siente más cómodo, ayuda a definir el perfil del inversionista.
        </p>
      </InfoModal>
      <p>
        El perfil de inversionista se refiere a las características de una persona que guían la
        manera en que debiera tomar sus decisiones de inversión, incluido su nivel de tolerancia al
        riesgo, en relación a los diversos instrumentos de inversión que existen en el mercado.
      </p>

      <p>
        En la medida que conozca qué tipo de inversionista es usted, podrá elegir de mejor forma
        entre las alternativas de inversión a las que puede optar o crear una mezcla de inversiones
        que se adapten a su perfil.
      </p>
      <p>Para poder asesorarte de mejor forma, necesitamos realizar algunas preguntas.</p>
    </div>

    <Button onClick={HandleSurvey} type="primary">
      Continuar
    </Button>
  </>

LegalProfile.propTypes = {
  HandleSurvey: PropTypes.func.isRequired,
};
export default LegalProfile;
